import { Skeleton } from '@mui/material';
import styles from './SkeletonContainer.module.scss';

interface IModalProps {
  hiddenTitle?: boolean;
}

const SkeletonContainer = ({ hiddenTitle }: IModalProps) => (
  <div data-testid="skeleton-container">
    {!hiddenTitle && (
      <div className={styles['header']} data-testid="skeleton-header">
        <Skeleton animation="wave" variant="text" height={50} width={145} />
        <Skeleton animation="wave" variant="circular" height={35} width={35} />
      </div>
    )}
    <div className={styles['top-tiles']}>
      {[...Array(5)].map((_n, i) => (
        <div key={`title-${i}`}>
          <Skeleton
            animation="wave"
            variant="text"
            height={32}
            width={145}
            data-testid="skeleton-top-tile"
            className={styles['top-tile']}
          />
        </div>
      ))}
    </div>
    <div className={styles['tiles']}>
      {[...Array(10)].map((_n, i) => (
        <Skeleton key={`row-${i}`} animation="wave" variant="rectangular" data-testid="skeleton-tile" />
      ))}
    </div>
  </div>
);

export default SkeletonContainer;
